"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILE_PREFIX = exports.EXPORT_FORMATS_NAMES = exports.EXPORT_FORMATS = void 0;
/**
 * @Author: Alexander Silva Barbosa
 * @Date:   2023-03-22 17:32:27
 * @Last Modified by:   Alexander Silva Barbosa
 * @Last Modified time: 2023-03-22 17:37:09
 */

const EXPORT_FORMATS = exports.EXPORT_FORMATS = {
  PDF: 'pdf',
  EXCEL: 'xlsx',
  MARKDOWN: 'md',
  JSON: 'json',
  HTML: 'html',
  CSV: 'csv',
  BIN: 'bin'
};
const EXPORT_FORMATS_NAMES = exports.EXPORT_FORMATS_NAMES = {
  pdf: 'PDF',
  xlsx: 'EXCEL',
  md: 'MARKDOWN',
  json: 'JSON',
  html: 'HTML',
  csv: 'CSV',
  bin: 'BIN'
};
const FILE_PREFIX = exports.FILE_PREFIX = {
  DOWNLOAD: 'download'
};